import Vue from "vue";
import axios from "axios";

export default {
  name: "ResetPassword",
  components: {
    NewPasswordComp: require("../../components/newPassword.vue").default,
  },
  data: function () {
    return {
      code: "",
      passwords: { password: "", password2: "", canContinue: false },
      completed: false,
      message: "",
      isInComm: false,
    };
  },
  computed: {
    resetEnabled: function () {
      return (
        this.passwords.canContinue &&
        this.passwords.password.length > 0 &&
        !this.isInComm &&
        !this.completed
      );
    },
  },
  methods: {
    redirectLogin() {
      this.$router.push("/login");
    },
    resetPassword() {
      let paramteters = {
        PasswordResetCode: this.code,
        Password: this.passwords.password,
      };

      console.log("Resetting password with parameters: ", paramteters);

      this.isInComm = true;
      axios
        .post("/account/ResetUserPassword", paramteters)
        .then((response) => {
          this.isInComm = false;
          this.completed = true;
          if (response.data.data.status == 0) {
            this.message =
              "Password reset successfully, you will be redirected to login page in a moment.";
            setTimeout(
              function () {
                this.redirectLogin();
              }.bind(this),
              2000
            );
          } else this.message = response.data.data.text;
        })
        .catch((e) => {
          this.message = e.message;
        });
    },
  },
  created() {
    // this.code = this.$route.params.code;
    this.code = this.$route.query.code;
  },
};
